function fallbackField(value) {
  return !value || value === 'None' ? 'Não informado' : value;
}

function normalizeDispatchChannel(value) {
  const normalizedValue = String(value || '').trim().toUpperCase();

  if (normalizedValue === 'WPP') {
    return 'WhatsApp';
  }

  if (normalizedValue === 'SMS') {
    return 'SMS';
  }

  if (normalizedValue === 'E-MAIL' || normalizedValue === 'EMAIL') {
    return 'E-mail';
  }

  return value || 'Não informado';
}

export function mapSummaryWithTotal(items = []) {
  const mappedData = items.map((item) => ({
    Campanha: item.nome_campanha,
    Descrição: item.descricao_campanha,
    'Data Execução': item.data_execucao,
    Entregues: item.status_entregue,
    Lidas: item.status_lido,
    'Não confirmadas': item.status_nao_confirmado,
    'Em espera': item.status_espera,
    Desconhecidas: item.status_desconhecido,
    Falhas: item.status_falha,
    Total: item.mensagens_totais,
  }));

  const totalLine = {
    Campanha: 'Total',
    Descrição: '',
    Total: 0,
    'Data Execução': '',
    Falhas: 0,
    Lidas: 0,
    Entregues: 0,
    'Não confirmadas': 0,
    'Em espera': 0,
    Desconhecidas: 0,
  };

  mappedData.forEach((item) => {
    totalLine.Total += item.Total || 0;
    totalLine.Falhas += item.Falhas || 0;
    totalLine.Lidas += item.Lidas || 0;
    totalLine.Entregues += item.Entregues || 0;
    totalLine['Não confirmadas'] += item['Não confirmadas'] || 0;
    totalLine['Em espera'] += item['Em espera'] || 0;
    totalLine.Desconhecidas += item.Desconhecidas || 0;
  });

  return [...mappedData, totalLine];
}

export function mapSentMessagesRows(items = [], page = 1, apiPageSize = 1000) {
  return items.map((item, index) => ({
    ...item,
    id: (page - 1) * apiPageSize + index + 1,
    'Título da campanha': item.titulo_da_campanha,
    'Data de envio': item.data_de_envio,
    'Modelo da mensagem': item.modelo_da_mensagem,
    'Contato destinatário': item.contato_destinatario,
    'Último Status': item.ultimo_status,
    'Tipo de canal': normalizeDispatchChannel(item.tipo_de_canal),
    'Data de início da campanha': item.data_de_inicio_da_campanha,
    'Data de fim da campanha': item.data_de_fim_da_campanha,
    'ID campanha enviada': item.id_campanha_enviada,
    'ID da Mensagem': item.id_da_mensagem,
    'Ordem da mensagem': item.ordem_da_mensagem,
    Banco: fallbackField(item.variavel_banco),
    'Código de Barras': fallbackField(item.variavel_codigo_barras),
    'Contrato ID': fallbackField(item.variavel_contrato_id),
    'CPF/CNPJ': fallbackField(item.variavel_cpf_cnpj),
    'Data de Vencimento': fallbackField(item.variavel_data_vencimento),
    'ID da Fatura': fallbackField(item.variavel_id_fatura),
    'Nome Completo': fallbackField(item.variavel_nome_completo),
    'Referência 01': fallbackField(item.variavel_referencia_01),
    'Referência 02': fallbackField(item.variavel_referencia_02),
    'Referência 03': fallbackField(item.variavel_referencia_03),
    'Referência 04': fallbackField(item.variavel_referencia_04),
    'Referência 05': fallbackField(item.variavel_referencia_05),
    'Valor Total': fallbackField(item.variavel_valor_total),
    WhatsApp: fallbackField(item.variavel_whatsapp),
  }));
}
